import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography"

import UploadDropzone from "./UploadDropzone";
import ImageScrollbar from "./ImageScrollbar";
import DocumentList from "./DocumentList";

const useStyles = makeStyles(() => ({
  zone: {
    marginTop: 35
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
}));

const Files = ({ addFiles = () => ({}), files, deleteOrg, editmode }) => {
  const classes = useStyles();

  return (
    <div className={classes.zone}>
      <Typography className={classes.heading}>Документы</Typography>
      <div>
        <DocumentList editmode={editmode} files={files} deleteOrg={deleteOrg} />
      </div>
      {editmode &&
      <div className={classes.zone}>
        <UploadDropzone onDrop={addFiles} />
      </div>}
    </div>
  );
};

export default Files;
